import React, { useState, useEffect, FC } from "react";
import { connect } from "react-redux";
import UserLink from "../../../utils/UserLink";
import { selectTrack, selectedTrack } from "../../../store/actions/track";
import { likeSong, playsCounter } from "../../../store/actions/songs";
import { playOrPause } from "../../../store/actions/audio";
import { firestore, auth } from "../../../firebase";
import UIkit from "uikit";
import { RootState } from "../../../store/reducers";
import { match, Link } from "react-router-dom";
import { Track } from "../../../models/track";
import { User } from "../../../models/user";

interface Props {
  track: Track;
  tid?: string;
  paused: boolean;
  current: Track;
  selectTrack: Function;
  selectedTrack: Function;
  playOrPause: Function;
  user: User;
}

const PlaylistTrack: FC<Props & IOProps> = ({
  track,
  tid,
  paused,
  current,
  selectTrack,
  selectedTrack,
  playOrPause,
  user,
}) => {
  const { username, title, id } = track;
  const [likes, setLikes] = useState<string[]>([]);
  const [active, setActive] = useState<boolean>(false);
  const [played, setPlayed] = useState<boolean>(false);

  const selectSong = (track: Track) => {
    if (!played) {
      if (id) playsCounter(id, user.id);
    }

    if (current.id !== id) {
      selectTrack(track);
      playOrPause();
    } else {
      selectTrack(track);
      playOrPause();
    }
  };

  useEffect(() => {
    setActive(current.id === track.id);
    let mounted = true;

    firestore
      .collection("songs")
      .doc(id)
      .onSnapshot((snap) => {
        if (snap.exists) {
          if (mounted) {
            setLikes(snap.data()?.likes);
            let loggedIn = auth.currentUser;

            if (loggedIn) {
              setPlayed(snap.data()?.plays.includes(loggedIn.uid));
            }
          }
        }
      });

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current]);

  const liked = likes.includes(user.id);

  return (
    <div
      id={tid}
      className={`list-track ${active ? `active` : ``}`}
      uk-scrollspy="cls: uk-animation-slide-left"
    >
      <div className="list-track-info">
        {
          <div
            className="icon"
            onClick={() => {
              selectSong(track);
            }}
          >
            <i className="material-icons">
              {current.id !== id || paused ? "play_arrow" : "pause"}
            </i>
          </div>
        }
        <div>
          <div
            className="smidek"
            onClick={() => {
              selectSong(track);
            }}
          >
            {title}
          </div>
          <div>
            <UserLink params={{ username }}>@{username}</UserLink>
          </div>
        </div>
      </div>
      <div className="list-track-action">
        <span
          style={{ color: liked ? "#f57f17" : "" }}
          onClick={() => {
            if (user) {
              if (id) likeSong(id);
            } else {
              UIkit.modal.dialog(
                `<p class="uk-modal-body">Login to use this feature</p>`
              );
            }
          }}
        >
          <span>{likes.length}</span>
          <i
            className="material-icons-outlined md-24"
            style={{ color: liked ? "#f57f17" : "" }}
          >
            favorite_border
          </i>
          {/* <Heart style={{ color: liked ? "#f57f17" : "" }} className="w20" /> */}
        </span>
        <span>
          <i className="material-icons-outlined md-24">share</i>
        </span>
        <span>
          <Link to={`/comments/${track.id}`}>
            <span>
              <i
                className="material-icons-outlined md-24 app-text"
                style={{ strokeWidth: "1px" }}
              >
                mode_comment
              </i>
            </span>
          </Link>
        </span>
        <span>
          <span
            uk-toggle="target: #track-modal"
            onClick={() => selectedTrack(track)}
          >
            <i className="material-icons-outlined md-24">more_horiz</i>
          </span>
        </span>
      </div>
    </div>
  );
};

interface IOProps<Params extends { pid?: string } = { pid?: string }> {
  history?: any;
  location?: any;
  match?: match<Params>;
  staticContext?: any;
}

const mapStateToProps = (state: RootState, ownprops: IOProps) => ({
  current: state.songs.current,
  audio: state.songs.audio,
  paused: state.songs.paused,
  user: state.auth.user,
  plist: state.data.playlists.find(
    (plist) => plist.id === ownprops.match?.params.pid
  ),
  // plist: state.playlist.playlists.find(plist => plist.id === ownprops.pid)
});

export default connect(mapStateToProps, {
  selectedTrack,
  selectTrack,
  playOrPause,
})(PlaylistTrack);
